export enum DocumentType {
  RUT = "RUT",
  PASSPORT = "PASSPORT",
}

export const DocumentTypeLabels: Record<DocumentType, string> = {
  [DocumentType.RUT]: "RUT",
  [DocumentType.PASSPORT]: "Pasaporte",
};

export interface Patient {
  rut: string | null;
  passport: string | null;
  name: string;
  firstSurname: string;
  secondSurname: string;
  birthdate: string;
  weight: string;
  email: string;
  phone: string;
  region: string;
  commune: string;
  street: string;
  streetNumber: string;
  chronicDiseases: string;
  allergies: string;
  uuid: string;
}

export enum DataSource {
  IMPORTED = "imported",
  GENERATED = "generated",
  CREATED = "created",
}

export interface PatientAttributes {
  id: number;
  uuid: string;
  documentNumber: string;
  name: string;
  socialName?: string;
  firstSurname: string;
  secondSurname?: string;
  birthdate?: Date;
  weight?: number;
  phone?: string;
  region?: string;
  commune?: string;
  street?: string;
  isMekiClient: boolean;
  hasYappInsurance: boolean;
  source: DataSource;
  disabled: boolean;
  email: string;
}

export type PatientBaseAttributes = Omit<
  Patient,
  "streetNumber" | "chronicDiseases" | "allergies"
>;

export const patientDefaultValues: Patient = {
  rut: "",
  passport: "",
  name: "",
  firstSurname: "",
  secondSurname: "",
  birthdate: "",
  weight: "",
  email: "",
  phone: "",
  region: "",
  commune: "",
  street: "",
  streetNumber: "",
  chronicDiseases: "",
  allergies: "",
  uuid: "",
};
